import React from 'react';
import { Lead } from '../../hooks/useLeads';

interface KeywordsProps {
  keywords?: string[];
  className?: string;
  signalId: string;
  onAdd: (keyword: string) => void;
}

const Keywords: React.FC<KeywordsProps> = ({ 
  keywords = [], 
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-start p-3 ${className}`}>
      <h2 className="text-[14px] font-medium text-[#222222] pr-2">
        Keywords
      </h2>
      <div className="flex flex-wrap gap-2 mt-3 rounded-lg border border-[#EEEEEE] p-2 max-h-full overflow-y-auto scrollbar-hide">
        {keywords && keywords.length > 0 ? (
          keywords.map((keyword, index) => (
            <span

              key={index}
              className={`inline-flex items-center gap-1 px-3 py-1 rounded-[8px] text-[14px]
                ${index % 3 === 0 ? 'bg-[#E5F9FF] text-[#0891B2]' : 
                  index % 3 === 1 ? 'bg-[#E5FFE6] text-[#16A34A]' : 
                  'bg-[#FFE5E5] text-[#DC2626]'}`}
            >
              {keyword}
            </span>
          ))
        ) : (
          <div className="w-full text-center py-4 text-[#7A7A7A] text-[14px]">
            No keywords available
          </div>
        )}
      </div>
    </div>
  );
};

export default Keywords; 